jQuery(document).ready(function () {
  // An offset to push the content down from the top
    var offset = jQuery('#jas-header').outerHeight();
    offset = offset + 50;
    // Click event
    jQuery('a[href^="#"]').on('click',function (event) {
      // Prevent from default action to intitiate
      event.preventDefault();
      
      // The id of the section we want to go to.
      var id = jQuery(this).attr("href");
      hash = "#";
      id = hash.concat(id);
      // Our scroll target : the top position of the
      // section that has the id referenced by our href.
      var target = jQuery(id).offset().top - offset;
            
      jQuery('html, body').animate({ scrollTop: target	}, 500, function () {
        //window.location.hash = '!' + id;
        window.location.hash = '!' + id;
      });
        
    });
    
    jQuery(window).load(function(){
      function goToByScroll(id){
          //alert(id);
          //alert(offset);

         jQuery('html, body').animate({scrollTop: jQuery(location.hash).offset().top - offset});
      } 
      
      if(window.location.hash != '') {
          goToByScroll(window.location.hash.substr(1));
      }
    });
  });